import Logo from "../../../assets/Logo.png";
import ImageGrid from "../../UI/ImageGrid/ImageGrid";

import { Box } from "@mui/system";

import React from "react";

const HeaderLogo = () => {
  return (
    <Box>
      <ImageGrid src={Logo} alt={"Logo"} maxWidth={{ maxWidth: "60px" }} />
    </Box>
  );
};

export default HeaderLogo;
